import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import Layout from "../components/layout/Layout";
import Login from "../pages/auth/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import EventList from "../pages/events/EventList";
import EventDetails from "../pages/events/EventDetails";
import UploadMedia from "../pages/gallery/UploadMedia";
import GalleryList from "../pages/gallery/GalleryList";
import GalleryDetail from "../pages/gallery/GalleryDetail";
import RoomList from "../pages/rooms/RoomList";
import RoomGalleries from "../pages/rooms/RoomGalleries";
import RunningUploads from "../pages/uploads/RunningUploads";
import AutoUpload from "../pages/auto-upload/AutoUpload";
import CompanionInstall from "../pages/companion/CompanionInstall";

const ProtectedRoute = ({ children }) => {
  const { token } = useAuth();
  return token ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<Login />} />

    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
    <Route path="/events" element={<ProtectedRoute><EventList /></ProtectedRoute>} />
    <Route path="/events/:id" element={<ProtectedRoute><EventDetails /></ProtectedRoute>} />
    <Route path="/events/:eventId/gallery/:galleryId" element={<ProtectedRoute><GalleryDetail /></ProtectedRoute>} />
    <Route path="/rooms" element={<ProtectedRoute><RoomList /></ProtectedRoute>} />
    <Route path="/rooms/:roomId/galleries" element={<ProtectedRoute><RoomGalleries /></ProtectedRoute>} />
    <Route path="/rooms/:roomId/gallery/:galleryId" element={<ProtectedRoute><GalleryDetail /></ProtectedRoute>} />
    <Route path="/uploads" element={<ProtectedRoute><RunningUploads /></ProtectedRoute>} />
    <Route path="/auto-upload" element={<ProtectedRoute><AutoUpload /></ProtectedRoute>} />
    <Route path="/companion" element={<ProtectedRoute><CompanionInstall /></ProtectedRoute>} />
    <Route path="/upload" element={<ProtectedRoute><UploadMedia /></ProtectedRoute>} />
    <Route path="/gallery" element={<ProtectedRoute><GalleryList /></ProtectedRoute>} />

    <Route path="/" element={<Navigate to="/dashboard" replace />} />
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

export default AppRoutes;
